import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-transaction-action-dropdown',
  templateUrl: './transaction-action-dropdown.component.html',
  styleUrls: ['./transaction-action-dropdown.component.css']
})
export class TransactionActionDropdownComponent {
  @Input() transaction: any;
  

  @Output() refund= new EventEmitter<any>();

}
